import { useState, useContext } from "react";

import { translate } from "@utils";
import { ActivePolicyContext, PoliciesContext } from "@modules/cve/context";
import { deletePolicy } from "@modules/cve/data";

import { ConfirmAction } from "@shared/components";

import MenuItem from "@mui/material/MenuItem";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

export const PoliciesTableRowActions = ({ row, hasWriteAccess, closeMenu, setOpenModal, setViewOnly }) => {
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const { setActivePolicy } = useContext(ActivePolicyContext);
	const { setPolicies } = useContext(PoliciesContext);

	let policy = row.original;

	const handleDelete = async () => {
		let result = await deletePolicy(policy.policyId);
		if (result.ok) setPolicies((prevState) => prevState.filter((prevPolicy) => prevPolicy.policyId !== policy.policyId));
		closeMenu();
	};

	let deleteMessage = (
		<div>
			<h4>{translate("cve_confirmDeletePolicy_message")}</h4>
			{policy.name ? <p>{policy.name}</p> : <></>}
		</div>
	);

	return (
		<>
			<MenuItem
				key="view"
				onClick={() => {
					setActivePolicy(policy);
					closeMenu();
					setViewOnly(true);
					setOpenModal(true);
				}}
			>
				<VisibilityOutlinedIcon style={{ marginRight: "10px" }} fontSize="small" />
				{translate("phrase_view")}
			</MenuItem>
			{hasWriteAccess && (
				<>
					<MenuItem
						key="edit"
						onClick={() => {
							setActivePolicy(policy);
							closeMenu();
							setOpenModal(true);
						}}
					>
						<CreateOutlinedIcon style={{ marginRight: "10px" }} fontSize="small" />
						{translate("edit")}
					</MenuItem>
					<MenuItem key="delete" onClick={() => setOpenDeleteModal(true)}>
						<DeleteOutlinedIcon style={{ marginRight: "10px" }} fontSize="small" />
						<ConfirmAction
							open={openDeleteModal}
							setOpen={setOpenDeleteModal}
							onCanceled={closeMenu}
							onConfirmed={handleDelete}
							confirmButtonText={translate("cve_confirmDeletePolicy_button")}
							message={deleteMessage}
						>
							{translate("delete")}
						</ConfirmAction>
					</MenuItem>
				</>
			)}
		</>
	);
};
